'use client'

import React, { useEffect } from 'react'

declare global {
  interface Window {
    initGoogleMapService: () => void
  }
}

interface Props {
  apiKey: string
  isAsyncLoading?: boolean
  onServiceLoaded?: () => void
}

/**
 * This component loads external services.
 * @service GoogleMaps
 */
const GoogleMapsServicesProvider: React.FC<Props> = ({
  apiKey,
  onServiceLoaded,
  isAsyncLoading
}) => {
  const loadGoogleMaps = (apiKey: string): void => {
    const script = document.createElement('script')
    const loadingParam = isAsyncLoading ? '&loading=async' : ''
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&language=es&libraries=places,geometry&callback=initGoogleMapService${loadingParam}`
    script.async = true

    window.initGoogleMapService = () => {
      if (onServiceLoaded) {
        onServiceLoaded()
      }
    }
    document.head.appendChild(script)
  }

  useEffect(() => {
    if (apiKey) {
      loadGoogleMaps(apiKey)
    }
  }, [apiKey])

  return null
}

export default GoogleMapsServicesProvider
